<template>
  <div>
    <template v-if="remarks && (remarks.word_count || remarks.similarity || (remarks.source_lang && remarks.target_lang))">
      <v-expansion-panels
        v-model="remark_panel"
        accordion
        multiple
        class="accordion pa-1"
        @click.stop
      >
        <template v-if="remarks.word_count">
          <v-expansion-panel>
            <v-expansion-panel-header
              @click.stop
            >
              {{ $t("message.file.estimate") }}
            </v-expansion-panel-header>
            <v-expansion-panel-content style="border:1px soild #000 !important">
              <v-simple-table
                dense
              >
                <template v-slot:default>
                  <tbody>
                    <tr>
                      <td>
                        {{ $t("message.file.word_count") }}
                      </td>
                      <td align="right">
                        {{ remarks.word_count }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </template>
        <template v-if="remarks.similarity">
          <v-expansion-panel>
            <v-expansion-panel-header
              @click.stop
            >
              {{ $t("message.file.similarity") }}
            </v-expansion-panel-header>
            <v-expansion-panel-content style="border:1px soild #000 !important">
              <v-card flat class="pa-2">
                <v-select
                  :label="$t('message.common.type')"
                  :items="similarity_types"
                  item-text="label"
                  item-value="value"
                  v-model="similarity_type"
                  hide-details
                  @click.stop
                >
                  <template v-slot:item="props">
                    {{ $t('message.common.' + props.item.label) }}
                  </template>
                  <template v-slot:selection="props">
                    {{ $t('message.common.' + props.item.label) }}
                  </template>
                </v-select>
              </v-card>
              <v-card
                flat
                @click.stop
              >
                <v-data-table
                  :headers="headers"
                  :items="data"
                  :sort-by="['score']"
                  :sort-desc="[true]"
                  must-sort
                  dense
                  class="elevation-1"
                  :footer-props="{
                    'items-per-page-options': [5, 10, 15, 100]
                  }"
                >
                  <template v-slot:header.score="{ header }">
                    {{ header.text }}
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          class="mb-2"
                          small
                          v-on="on"
                        >
                          mdi-help-circle-outline
                        </v-icon>
                      </template>
                      <span>{{ $t("message.file.score_desc") }}</span>
                    </v-tooltip>
                  </template>
                  <template v-slot:item.type="{ item }">
                    {{ $t("message.common." + item.type) }}
                  </template>
                  <template v-slot:item.model="{ item }">
                    <IdName
                      :mode="mode"
                      :ids="[item.model]"
                      :type="item.type"
                      :nav_path="nav_path"
                      :remarks="null"
                      :source="fid"
                      :key="item.model"
                    />
                  </template>
                  <template v-slot:item.score="{ item }">
                    {{ item.score.toFixed(1) }}
                  </template>
                </v-data-table>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </template>
        <template v-if="remarks.source_lang && remarks.target_lang">
          <v-expansion-panel>
            <v-expansion-panel-header
              @click.stop
            >
              {{ $t("message.common.direction") }}
            </v-expansion-panel-header>
            <v-expansion-panel-content style="border:1px soild #000 !important">
              <v-simple-table
                dense
              >
                <template v-slot:default>
                  <tbody>
                    <tr>
                      <td>
                        {{ $t("message.common.direction") }}
                      </td>
                      <td>
                        {{ $t("message.common.lang_" + remarks.source_lang) }}
                        &rarr;
                        {{ $t("message.common.lang_" + remarks.target_lang) }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </template>
      </v-expansion-panels>
    </template>
    <template v-else>
      -
    </template>
  </div>
</template>

<script>
export default {
  name: 'file_remark',
  props: {
    fid: String,
    remarks: Object,
    mode: String,
    nav_path: String,
    visible: Array
  },
  components: {
    IdName: () => import('../components/IdName.vue')
  },
  data: function(){
    var remark_panel = [];
    var remark_panel_index = 0;
    if(this.remarks && this.remarks.word_count){
      if(this.visible.indexOf("estimate") >= 0){
        remark_panel.push(remark_panel_index);
      }
      remark_panel_index++;
    }
    if(this.remarks && this.remarks.similarity){
      if(this.visible.indexOf("similarity") >= 0){
        remark_panel.push(remark_panel_index);
      }
      remark_panel_index++;
    }
    return {
      module_id: "63",
      data: [],
      similarity_type: ["model", "corpus"],
      similarity_types: [
        {
          label: "all",
          value: ["model", "corpus"]
        },
        {
          label: "model",
          value: ["model"]
        },
        {
          label: "corpus",
          value: ["corpus"]
        }
      ],
      remark_panel: remark_panel
    }
  },
  mounted: function(){
    if(this.remarks
      && this.remarks.similarity){
      var data = [];
      for(var model in this.remarks.similarity){
        data.push({
          type: this.remarks.similarity[model].type,
          model: model,
          score: this.remarks.similarity[model].score
        });
      }
      this.data = data;
    }
  },
  computed: {
    headers: function() {
      return [
        {
          text: this.$i18n.t("message.common.type"),
          value: 'type',
          filter: value => {
            if(this.similarity_type === null){
              return true;
            }
            return this.similarity_type.indexOf(value) >= 0;
          }
        },
        {
          text: this.$i18n.t("message.file.model"),
          value: 'model'
        },
        {
          text: this.$i18n.t("message.file.score"),
          value: 'score',
          align: 'right'
        }
      ];
    }
  }
}
</script>
<style scoped>
.v-data-table {
  border: 1px solid rgba(0, 0, 0, 0.12);
}
</style>
